import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Controller, useForm } from 'react-hook-form';
import { Column, ConfirmationModal, FullColumn, IconButton, Row, TextField, Typography, useOverlayContext } from 'seagull';
import { ThumbDown24, ThumbDownFilled24, ThumbUp24, ThumbUpFilled24 } from 'seagull/icons';
import { useSubmitServiceDescriptionFeedback } from '~/hooks/reactQuery/mutations/useSubmitServiceDescriptionFeedback';
import { useStoreActions } from '~/store/store-context';
import { FeedbackModalTestIds } from './FeedbackModal.utils';
const FeedbackModal = (param)=>{
    let { conversationId, onClose } = param;
    const { logBI } = useStoreActions();
    const { submitFeedback, isLoading } = useSubmitServiceDescriptionFeedback();
    const { showSuccessToast } = useOverlayContext();
    const { control, handleSubmit, formState: { errors } } = useForm({
        mode: 'onSubmit',
        defaultValues: {
            rating: null,
            comment: ''
        }
    });
    const showError = !!errors.rating;
    const handleRatingChange = (newRating)=>{
        if (newRating === 'thumbsUp') {
            logBI(17012);
        } else if (newRating === 'thumbsDown') {
            logBI(17013);
        }
    };
    const onSubmit = async (data)=>{
        const feedbackText = data.comment.trim() || undefined;
        logBI(17014, {
            feedbackText
        });
        await submitFeedback({
            conversationId,
            data: {
                rating: data.rating,
                comment: feedbackText
            }
        });
        showSuccessToast('Thanks for your feedback!', FeedbackModalTestIds.SuccessToast());
        onClose();
    };
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        width: "550px",
        title: "Your feedback helps us improve",
        showFooter: true,
        onPrimaryButtonClick: handleSubmit(onSubmit),
        primaryButtonLabel: "Submit",
        primaryButtonLoading: isLoading,
        primaryButtonTestId: FeedbackModalTestIds.SubmitButton(),
        secondaryButtonLabel: "Close",
        onSecondaryButtonClick: onClose,
        secondaryButtonTestId: FeedbackModalTestIds.CloseButton(),
        content: /*#__PURE__*/ _jsxs(FullColumn, {
            gap: 16,
            children: [
                /*#__PURE__*/ _jsxs(Row, {
                    alignItems: "center",
                    gap: 8,
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "paragraph1",
                            testId: FeedbackModalTestIds.RatingQuestion(),
                            children: "How would you rate the suggestions?"
                        }),
                        /*#__PURE__*/ _jsx(Controller, {
                            control: control,
                            name: "rating",
                            rules: {
                                required: 'Please select a rating'
                            },
                            render: (param)=>{
                                let { field: { onChange, value } } = param;
                                return /*#__PURE__*/ _jsxs(Row, {
                                    gap: 4,
                                    children: [
                                        /*#__PURE__*/ _jsx(IconButton, {
                                            onClick: ()=>{
                                                const newValue = value === 'thumbsUp' ? null : 'thumbsUp';
                                                handleRatingChange(newValue);
                                                onChange(newValue);
                                            },
                                            testId: FeedbackModalTestIds.ThumbsUpButton(),
                                            "data-selected": value === 'thumbsUp',
                                            "data-error": showError && !value ? 'true' : undefined,
                                            skin: showError && !value ? 'error' : 'standard',
                                            children: value === 'thumbsUp' ? /*#__PURE__*/ _jsx(ThumbUpFilled24, {}) : /*#__PURE__*/ _jsx(ThumbUp24, {})
                                        }),
                                        /*#__PURE__*/ _jsx(IconButton, {
                                            onClick: ()=>{
                                                const newValue = value === 'thumbsDown' ? null : 'thumbsDown';
                                                handleRatingChange(newValue);
                                                onChange(newValue);
                                            },
                                            testId: FeedbackModalTestIds.ThumbsDownButton(),
                                            "data-selected": value === 'thumbsDown',
                                            "data-error": showError && !value ? 'true' : undefined,
                                            skin: showError && !value ? 'error' : 'standard',
                                            children: value === 'thumbsDown' ? /*#__PURE__*/ _jsx(ThumbDownFilled24, {}) : /*#__PURE__*/ _jsx(ThumbDown24, {})
                                        })
                                    ]
                                });
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(Column, {
                    gap: 8,
                    alignItems: "start",
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "paragraph1",
                            testId: FeedbackModalTestIds.CommentLabel(),
                            children: "Please share your thoughts:"
                        }),
                        /*#__PURE__*/ _jsx(Controller, {
                            control: control,
                            name: "comment",
                            render: (param)=>{
                                let { field } = param;
                                return /*#__PURE__*/ _jsx(TextField, _object_spread_props(_object_spread({
                                    collapseHelperText: false
                                }, field), {
                                    multiline: true,
                                    minRows: 3,
                                    maxRows: 3,
                                    placeholder: "Write here...",
                                    testId: FeedbackModalTestIds.CommentInput()
                                }));
                            }
                        })
                    ]
                })
            ]
        }),
        onCloseButtonClick: onClose,
        testId: FeedbackModalTestIds.Root()
    });
};
export default FeedbackModal;
